<template>
 
    <div class="loading" v-show="load_show">
        <div class="pic">
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
        </div>
    </div>

</template>

<script>
export default {
    computed:{
        load_show(){return this.$store.state.load_show}
    }
}
</script>

<style scoped>
.loading{width:100%; height: 100%;position: fixed;top:0;left: 0;z-index: 100;background: #0e0c0cdb;z-index: 99999;}
.loading .pic{
width: 64px;
height: 64px;

position: absolute;
top: 0;
bottom: 0;
left:0;
right:0;
margin: auto}
.loading .pic i{
    display: block;
    float: left;
    width: 8px;
    height: 60px;
    background: #399;
    margin: 0 2px;
    transform: scaleY(0.4);
    animation: load 1.2s infinite;
}
.loading .pic i:nth-child(1){animation-delay:0.1s }
.loading .pic i:nth-child(2){animation-delay:0.2s }
.loading .pic i:nth-child(3){animation-delay:0.3s }
.loading .pic i:nth-child(4){animation-delay: 0.4s}
.loading .pic i:nth-child(5){animation-delay:0.5s }
@keyframes load{
    0%,40%,100%{transform: scaleY(0.4)}
    20%{transform:scaleY(1) }
}
</style>